import { CircularProgress as MuiCircularProgress, circularProgressClasses as muiCircularProgressClasses, } from '@mui/material';
export const CircularProgress = MuiCircularProgress;
export const circularProgressClasses = muiCircularProgressClasses;
